package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/zootopia-2". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/zootopia-2")
@Composable
fun Zootopia2ReviewPage() {
    PublicReviewPage(
        slug = "zootopia-2",
        blurb = "Is Zootopia 2 OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
